import * as exifr from 'exifr';

type ExtractedImageMetadata = {
  capturedAt: string | null;
};

const normalizeExifDate = (value: unknown): string | null => {
  if (!value) {
    return null;
  }

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString();
  }

  if (typeof value === 'string') {
    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toISOString();
    }
  }

  return null;
};

export const extractImageMetadata = async (file: File): Promise<ExtractedImageMetadata> => {
  try {
    // Comentario em pt-BR: a ideia aqui e pegar so o essencial da EXIF.
    // Se o navegador ou a imagem nao trouxerem isso, a evidencia continua valendo.
    const metadata = await exifr.parse(file, [
      'DateTimeOriginal',
      'CreateDate',
      'OffsetTimeOriginal'
    ]);

    return {
      capturedAt: normalizeExifDate(metadata?.DateTimeOriginal || metadata?.CreateDate)
    };
  } catch {
    return {
      capturedAt: null
    };
  }
};

export const didEvidenceDateMismatch = (capturedAt?: string | null, completedAt?: string | null) => {
  if (!capturedAt || !completedAt) {
    return false;
  }

  const capturedDate = capturedAt.slice(0, 10);
  const completedDate = completedAt.slice(0, 10);
  return capturedDate !== completedDate;
};
